import fleetHeroImg from '@/assets/marketing/images/large-fleets-hero.jpg'
import { Button } from '@/components/ui/button'
import { trackMarketingCta } from '@/lib/analytics'
import { Reveal } from '../marketing/components/Reveal'

export const PACKET_FORM_ID = 'packet-form'

export function LargeFleetHero() {
  return (
    <section className="bg-ink-900 relative overflow-hidden">
      <img
        src={fleetHeroImg}
        alt=""
        className="absolute inset-0 h-full w-full object-cover"
        fetchPriority="high"
      />
      {/* Only thins out at lg, where max-w holds the copy inside the dark end; narrower, it reflows wide over the trucks and needs the cover. */}
      <div className="from-ink-900/95 via-ink-900/85 to-ink-900/80 lg:to-ink-900/40 absolute inset-0 bg-gradient-to-r" />
      <div className="relative mx-auto max-w-(--maxw) px-5.5 py-24 lg:py-32">
        <Reveal className="flex max-w-225 flex-col gap-6.5">
          <span className="text-brand-500 font-mono text-xs font-bold tracking-[0.14em] uppercase">
            Insurance for large fleets
          </span>
          <h1 className="h1-hero max-w-[19ch] text-pretty text-white">
            Trucking insurance that keeps up with your fleet
          </h1>
          <p className="max-w-190 text-xl leading-[1.55] text-pretty text-white/80">
            We used to run our own fleet. Then we built the insurance experience we wished we had: fast
            quoting, instant COIs, and easy policy management.
          </p>
          <div className="mt-1 flex flex-wrap items-center gap-5">
            <Button
              size="lg"
              href={`#${PACKET_FORM_ID}`}
              onClick={() => trackMarketingCta('large_fleet_packet_hero_get_quote')}
            >
              Get your quotes
            </Button>
            <span className="text-ink-300 text-md">No requirement to buy</span>
          </div>
        </Reveal>
      </div>
    </section>
  )
}
